module.exports = __webpack_public_path__ + "static/media/0029_IMG_L_ESPACE_DE_RESTAURATION.715fa1d8.webp";